import styles from './ContactHero.module.css';

export default function ContactHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Contact us</span>
        <h1 className={styles.headline}>Let's talk.</h1>
        <p className={styles.sub}>
          Sales, support, partnerships, or press: send it over and we'll reply within one
          business day.
        </p>
      </div>
    </section>
  );
}
